<template>
  <v-main class="document landscape">
    <v-container fluid v-if="!loading" class="container-print">
      <div class="row px-6 pt-6 pb-6">
        <div class="pl-0">
          <div class="headline primary--text mb-2">{{ fields.name }}</div>
          <div class="row ma-0">
            <div class="no-wrap">
              <small>Valor por pessoa</small>
              <br>
              <b>{{ fields.unit_price | price }}</b>
            </div>
            <div class="no-wrap ml-8">
              <small>Termina em</small>
              <br>
              <b>{{ fields.finish_date | moment('MM/YYYY') }}</b>
            </div>
            <div class="no-wrap ml-8">
              <small>Total Pago (Externo + Heppi)</small>
              <br>
              <b>{{ totalPaid | price }}</b>
            </div>
            <div class="no-wrap ml-8">
              <small>Total Atrasado</small>
              <br>
              <b>{{ totalLate | price }}</b>
            </div>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="text-right primary--text">
          <img src="@/assets/logo-heppi.png" srcset="@/assets/logo-heppi@2x.png 2x" style="height: 40px" />
          <br>
          <span class="title">{{ celebration && celebration.name }}</span>
        </div>
      </div>
      <v-data-table
        class="pt-6 table-report"
        dense
        :headers="headers"
        :items="fields.participants"
        :loading="loading"
        :disable-pagination="true"
        no-data-text="Nenhum participante"
        no-results-text="Nenhum participante"
        :hide-default-footer="true"
      >
        <template v-slot:item.name="{ item }">
          {{ item.name }}
          <br>
          <small>{{ item.person_document | documentMasked }}<span class="error--text" v-if="item.amount_to_pay === 0"> (Desistente)</span></small>
        </template>
        <template v-slot:item.joined_created_at="{ item }">
          {{ item.joined_created_at | moment('MM/YYYY') }}
        </template>
        <template v-slot:item.amount_to_pay="{ item }">
          <span style="white-space: nowrap">{{ item.amount_to_pay | price }}</span>
        </template>
        <template v-slot:item.total_paid="{ item }">
          <span style="white-space: nowrap">{{ item.total_paid | price }}</span>
        </template>
        <template v-slot:item.total_paid_before="{ item }">
          <span style="white-space: nowrap">{{ item.total_paid_before | price }}</span>
        </template>
        <template v-slot:item.total_paid_without_interest_and_fine="{ item }">
          <span style="white-space: nowrap">{{ item.total_paid_without_interest_and_fine | price }}</span>
        </template>
        <template v-slot:item.total_paid_interest_and_fine="{ item }">
          <span style="white-space: nowrap">{{ item.total_paid_interest_and_fine | price }}</span>
        </template>
        <template v-slot:item.total_late="{ item }">
          <span style="white-space: nowrap">{{ item.total_late | price }}</span>
        </template>
        <template v-slot:item.payment_method="{ item }">
          <span style="white-space: nowrap">
            <template v-if="item.number_of_installment">
              {{ item.number_of_installment }}x <small>({{ item.method | payment_method }}<template v-if="item.period && item.period !== 'ALL'"> | {{ item.period }}</template>)</small>
            </template>
            <template v-else>
              <small>Sem parcelas</small>
            </template>
          </span>
        </template>
      </v-data-table>
      <div class="pt-4 text-right">
        <i class="caption">Documento gerado no dia {{ now }}</i>
      </div>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'

export default {
  name: 'fundraisingForm',
  components: {
    AppLoading
  },
  props: ['celebrationId', 'id'],
  data: () => ({
    loading: false,
    openDialog: false,
    celebration: {},
    fields: {
      name: '',
      description: '',
      image: null,
      start_date: '',
      finish_date: '',
      unit_price: 0,
      people_quantity: 0,
      goal: 0,
      total_late: 0,
      total_paid: 0,
      participants: []
    },
    headers: [
      {
        text: 'Nome',
        value: 'name',
        sortable: false
      },
      {
        text: 'Entrou em',
        value: 'joined_created_at',
        sortable: false,
        align: 'center'
      },
      {
        text: 'Meta',
        value: 'amount_to_pay',
        sortable: false,
        align: 'right'
      },
      {
        text: 'Total Pago',
        value: 'total_paid',
        sortable: false,
        align: 'right'
      },
      {
        text: 'Pago por fora',
        value: 'total_paid_before',
        sortable: false,
        align: 'right'
      },
      {
        text: 'Pago Heppi',
        value: 'total_paid_without_interest_and_fine',
        sortable: false,
        align: 'right'
      },
      {
        text: 'Juros pago',
        value: 'total_paid_interest_and_fine',
        sortable: false,
        align: 'right'
      },
      {
        text: 'Atrasado',
        value: 'total_late',
        sortable: false,
        align: 'right'
      },
      {
        text: 'Pagamento',
        value: 'payment_method',
        sortable: false
      }
    ],
    now: ''
  }),
  computed: {
    totalPaid () {
      let totalPaid = 0
      if (this.fields && this.fields.participants) {
        for (const index in this.fields.participants) {
          const participant = this.fields.participants[index]
          totalPaid += parseFloat(participant.total_paid)
        }
      }
      return totalPaid
    },
    totalLate () {
      let totalLate = 0
      if (this.fields && this.fields.participants) {
        for (const index in this.fields.participants) {
          const participant = this.fields.participants[index]
          totalLate += parseFloat(participant.total_late)
        }
      }
      return totalLate
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR'])
  },
  async created () {
    if (this.id) {
      let vue = this
      vue.loading = true

      await axios.get('celebrations/' + vue.celebrationId)
        .then(response => {
          if (response.data) {
            vue.celebration = response.data
          }
        })

      axios.get('fundraisings/' + vue.id)
        .then(response => {
          if (response.data) {
            vue.loading = false
            for (let key in vue.fields) {
              if (response.data[key]) vue.fields[key] = response.data[key]

              if (key === 'participants') {
                vue.fields[key].sort((a, b) => {
                  if (a.amount_to_pay === 0 && b.amount_to_pay !== 0) return 1
                  if (b.amount_to_pay === 0 && a.amount_to_pay !== 0) return -1
                  if (a.name.toUpperCase() < b.name.toUpperCase()) return -1
                  if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
                  return 0
                })
              }
            }
            setTimeout(() => {
              window.print()
            }, 1000)
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.$router.go(-1)
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$router.go(-1)
        })
    }

    this.now = this.$moment().format('DD/MM/YYYY HH:mm')
  }
}
</script>

<style>
.container-print {
  padding: 30px;
}

.table-report th {
  white-space: nowrap;
}

@media print {
  .container-print {
    padding: 0 1cm;
    margin-top: -1cm;
  }
}

@page { margin: 1cm !important } /* All margins set to 2cm */

</style>
